import {
  FETCH_MAP_PROPERTIES_REQUEST,
  FETCH_MAP_PROPERTIES_SUCCESS,
  FETCH_MAP_PROPERTIES_FAILURE,
  RESET_MAP,
} from './constants'
import type { MapActions } from './actions'
import type { mapDataSearchMapToPropertiesCollection } from './mappers'

export interface MapState {
  properties: ReturnType<typeof mapDataSearchMapToPropertiesCollection>
  isFetchingProperties: boolean
  error: string | null
  offset: number
}
const initialState: MapState = {
  properties: [],
  isFetchingProperties: true,
  error: null,
  offset: 30,
}

const mapReducer = (state = initialState, action: MapActions) => {
  switch (action.type) {
    case FETCH_MAP_PROPERTIES_REQUEST:
      return {
        ...state,
        isFetchingProperties: true,
      }

    case FETCH_MAP_PROPERTIES_SUCCESS:
      if (action.payload.keepProperties) {
        return {
          ...state,
          error: null,
          isFetchingProperties: false,
          properties: [...state.properties, ...action.payload.properties],
        }
      }

      return {
        ...state,
        error: null,
        isFetchingProperties: false,
        properties: action.payload.properties,
      }

    case FETCH_MAP_PROPERTIES_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        isFetchingProperties: false,
      }

    case RESET_MAP:
      return {
        ...state,
        isFetchingProperties: true,
        properties: [],
      }

    default:
      return state
  }
}

export default mapReducer
